import { ActionReducerMap } from '@ngrx/store';
import { quoteReducer } from './quote/stores/quote.reducer';
import { proposalReducer } from './quote/stores/proposal.reducer';
import { pricesReducer } from './quote/stores/prices.reducer';
import * as wizard from './quote/stores/wizard.reducer';
import * as auth from './auth/auth.reducer';
import * as common from './common/common.reducer';

export interface AppState {
  quote: any;
  proposal: any;
  quotePrices: any;
  brokerSessionInfo: any;
  userGroups: any;
  viewToast: common.State;
  wizard: wizard.State;
}

export const appReducers: ActionReducerMap<AppState> = {
  quote: quoteReducer,
  proposal: proposalReducer,
  quotePrices: pricesReducer,
  brokerSessionInfo: auth.brokerSessionInfoReducer,
  userGroups: auth.userGroupsReducer,
  viewToast: common.commonReducer,
  wizard: wizard.wizardReducer,
};
